
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { SalesOrder } from '@/api/model';
import OrderCard from '@/components/orders/OrderCard.vue';
import Helpers from '@/logic/orders/helpers';
import OrderStatus from '@/components/orders/OrderStatus.vue';
import OrderOverviewTableDetails from '@/components/orders/OrderOverviewTableDetails.vue';

@Component({
  components: { OrderOverviewTableDetails, OrderCard, OrderStatus },
})
export default class OrderOverviewTable extends Vue {
  @Prop({ type: Number, default: 0 })
  perPage!: number;

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  @Prop({ type: Array, default: () => [] })
  orders!: SalesOrder[];

  currentPage = 1;

  Helpers = Helpers;

  get paginatedOrders(): SalesOrder[] {
    if (this.perPage === 0) {
      return this.orders;
    }
    return this.orders.slice(
      (this.currentPage - 1) * this.perPage,
      this.currentPage * this.perPage,
    );
  }

  get openedDetails(): string[] {
    const active = this.$store.state.order.activeOrders;
    return Array.from(active);
  }

  @Watch('$route', { immediate: true })
  routeChanged(newVal: any) {
    this.currentPage = parseInt(newVal.hash.replace(/#page/g, ''), 10) || 1;
  }

  toggleActive(order: SalesOrder, active?: boolean) {
    if (active === undefined) {
      active = !this.isDetailed(order);
    }
    this.$store.commit('order/toggleActive', {
      id: order.Id,
      active,
    });
  }

  isDetailed(order: SalesOrder) {
    return this.$store.getters['order/isActive'](order.Id);
  }

  etaActualClass(order: SalesOrder): any {
    if (!order.OriginalEta || !order.UpdatedEta) {
      return {};
    }
    return {
      'eta--early': order.OriginalEta > order.UpdatedEta,
      'eta--late': order.OriginalEta < order.UpdatedEta,
    };
  }
}
